<template>
  <div class="animated fadeIn">
    <!-- <StyledDialog>
      <div slot="header">
        <h2>{{seminar.restaurant_edit.CommonName}}</h2>
      </div>
      <div slot="details">
        <div>{{seminar.restaurant_edit.Address1}} {{seminar.restaurant_edit.Address2}}</div>
        <div>{{seminar.restaurant_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>-->
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Filter Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="lpfilter.filter_edit.LPFilterName"
                    placeholder="Filter Name"
                    required
                    type="text"
                    autocomplete="off"
                    id="LPFilterName"
                    @change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Description</b-input-group-text
                    >
                  </b-input-group-prepend>

                  <b-form-input
                    v-model.lazy="lpfilter.filter_edit.LPFilterDesc"
                    placeholder="Description"
                    type="text"
                    autocomplete="off"
                    id="LPFilterDesc"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- 
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-globe"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <CoolSelect
                  v-model="lpfilter.filter_edit.MinAgeParamID"
                  theme="bootstrap"
                  tooltip="Vendor"
                  :items="lpfilter.filters_param_age.Options"
                  item-text="FilterParamDisplay"
                  item-value="FilterParamOptionID"
                  id="MinAgeParamID"
                  @select="setMinimumAge"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Mininimum Age.</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <CoolSelect
                  v-model="lpfilter.filter_edit.MaxAgeParamID"
                  theme="bootstrap"
                  tooltip="Maximum Age"
                  :items="lpfilter.filters_param_age.Options"
                  item-text="FilterParamDisplay"
                  item-value="FilterParamOptionID"
                  id="MaxAgeParamID"
                  @select="setMaximumAge"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Maximum Age.</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <CoolSelect
                  v-model="lpfilter.filter_edit.MinIncomeParamID"
                  theme="bootstrap"
                  tooltip="Minimum Income"
                  :items="lpfilter.filters_param_income.Options"
                  item-text="FilterParamDisplay"
                  item-value="FilterParamOptionID"
                  id="MinIncomeParamID"
                  @select="setMinimumIncome"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Minimum Income</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <LPParameterContainer
                :lpfilter_object="lpfilter.filter_edit"
                :param_object="lpfilter.filter_edit.GenderParam"
                :key="
                  createUniqueKey(lpfilter.filter_edit.GenderParam.LPParamID)
                "
                param_title="Gender"
              />
            </b-col>
            <b-col md="6">
              <LPParameterContainer
                :lpfilter_object="lpfilter.filter_edit"
                :param_object="lpfilter.filter_edit.EducationParam"
                :key="
                  createUniqueKey(lpfilter.filter_edit.EducationParam.LPParamID)
                "
                param_title="Education"
              />
            </b-col>
          </b-row>

          <!-- <b-row>
            <b-col md="4">
              <b-form-checkbox-group
                id="basicInlineCheckboxes"
                name="InlineCheckboxes"
                :plain="true"
                :checked="lpfilter.filter_edit.MFDUExclusion.SelectedOptions"
              >
                <b-form-checkbox :plain="true" value="80"
                  >Exclude Multi-Family Dwelling Units</b-form-checkbox
                >
              </b-form-checkbox-group>
            </b-col>
          </b-row> -->

          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Close
            </b-button>
            <b-button
              class="mr-0 mt-2"
              type="submit"
              size="md"
              variant="primary"
              :disabled="isClean"
              @click="save"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { CoolSelect } from "vue-cool-select";
import Treeselect from "@riophae/vue-treeselect";
import LPParameterContainer from "@/components/CustomSubComponents/LPParameterContainer.vue";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "LPFilterProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      renderCounter: 0
    };
  },
  methods: {
    createUniqueKey(valin) {
      return valin + "_" + this.renderCounter;
    },
    setMinimumAge(event) {
      this.addDirtyFieldSpecial("MinAge", event.FilterParamDisplay);
      this.addDirtyFieldSpecial("MinAgeParamID", event.FilterParamOptionID);
    },
    setMaximumAge(event) {
      this.addDirtyFieldSpecial("MaxAge", event.FilterParamDisplay);
      this.addDirtyFieldSpecial("MaxAgeParamID", event.FilterParamOptionID);
    },
    setMinimumIncome(event) {
      this.addDirtyFieldSpecial("MinIncome", event.FilterParamDisplay);
      this.addDirtyFieldSpecial("MinIncomeParamID", event.FilterParamOptionID);
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );
      }
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldSpecial: function(fld, val) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== fld
      );
      this.dirtyFields.push({
        FieldName: fld,
        FieldValue: val
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  computed: {
    ...mapState(["lpfilter"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    ...mapGetters("lpfilter", ["getFilterParamByID"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    StyledDialog,
    CoolSelect,
    Treeselect,
    LPParameterContainer
  },
  created() {},

  mounted() {
    this.$store.state.saveOp.localUrl = "/LPFilter/SaveLPFilter/";
    this.$store.state.saveOp.localVariableName = "_f";
    this.$store.state.saveOp.localVariableObject = this.$store.state.lpfilter.filter_edit;
    this.$store.state.saveOp.localFieldToSet = "LPFilterID";
    this.$store.state.saveOp.localReturnObject = "SaveLPFilterResult";
  },
  validations: {
    lpfilter: {
      filter_edit: {
        LPFilterName: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
